import React, { useRef } from 'react';
import { useTheme } from '@mui/material/styles';
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip, Legend } from 'recharts';
import ExportButtons from '../Common/ExportButtons';

export interface DonutSlice {
  name: string;
  value: number;
  color?: string;
}

interface Props {
  data: DonutSlice[];
  height?: number;
  ariaLabel?: string;
}

const BipartisanDonut: React.FC<Props> = ({ data, height = 260, ariaLabel = 'Bipartisan split' }) => {
  const theme = useTheme();
  const colors = data.map((d, i) => d.color || (i % 2 === 0 ? theme.palette.primary.main : theme.palette.secondary.main));
  const containerRef = useRef<HTMLDivElement | null>(null);

  return (
    <div ref={containerRef} role="img" aria-label={ariaLabel} style={{ width: '100%', height }}>
      <ExportButtons filename="bipartisan" data={data as any} containerRef={containerRef as any} />
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            innerRadius={60}
            outerRadius={90}
            paddingAngle={2}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={colors[index]} />
            ))}
          </Pie>
          <Tooltip contentStyle={{ background: theme.palette.background.paper, border: `1px solid ${theme.palette.divider}`, borderRadius: 8 }} />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default BipartisanDonut;
